import { Button } from '@backstage/ui';
import { Icon } from '@iconify/react';
import { ProductEntityFilter } from '@ipen-portal/ipen-entity-model';
import { useGetEntitiesByFilter } from '@ipen-portal/plugin-common-react';
import { useNavigate } from 'react-router-dom';

import { useShuffledEntities } from '../../hooks/useShuffledEntities';
import classes from './AppHomeCard.module.css';
import { HomeEntityCard } from './components/HomeEntityCard';

export const AppHomeCard = () => {
  const { data, isError, isPending } = useGetEntitiesByFilter(ProductEntityFilter);
  const applications = useShuffledEntities(data);
  const navigate = useNavigate();
  const message = isError
    ? 'Applications could not be loaded.'
    : !isPending && !data.length ? 'No applications available.' : undefined;

  return (
    <HomeEntityCard
      aria-label="iPEN Applications"
      className={classes.root}
      entities={applications}
      footerAction={(
        <Button
          aria-label="Explore more"
          className={classes.explore}
          onPress={() => navigate('/catalog?filters[kind]=System&filters[type]=product')}
          variant="secondary"
        >
          <Icon aria-hidden="true" icon="ri:arrow-right-s-line" />
          Explore more
        </Button>
      )}
      loading={isPending}
      message={message}
      showImages
      title="Check out the iPEN Applications"
    />
  );
};
